import { AuthService } from "@/services";

export default {
  name: "captcha",
  components: {},
  props: ["captchaHash", "reloadCaptcha", "captchaType"],
  data() {
    return { captchaData: {}, captchaValue: "" };
  },
  computed: {},
  mounted() {
    this.getCaptchaData();
  },
  methods: {
    getCaptchaData() {
      AuthService.captcha(this.captchaType, this.captchaHash).then(response => {
        this.resetValue();
        this.passData(this.captchaValue, response.data.data.token);
        this.captchaData = response.data.data;
      });
    },
    resetValue() {
      this.captchaValue = "";
    },
    passData(value, token) {
      let data = { value, token };
      this.$emit("changed", data);
    }
  },
  watch: {
    reloadCaptcha() {
      this.getCaptchaData();
    }
  }
};
